import { render, staticRenderFns } from "./AdminProfileModal.vue?vue&type=template&id=0f353522&scoped=true"
import script from "./AdminProfileModal.vue?vue&type=script&lang=ts"
export * from "./AdminProfileModal.vue?vue&type=script&lang=ts"
import style0 from "./AdminProfileModal.vue?vue&type=style&index=0&id=0f353522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f353522",
  null
  
)

export default component.exports